<template>
  <lb-dialog :value="value" @input="updateValue" :heading="title" width="600">
    <template v-slot:body>
      <div class="d-flex flex-column gap-3">
        <v-chip v-if="message" class="noTransform ru-info-chip gap-2 align-center">
            <span class="d-flex align-center gap-2">
              <img v-if="image" :src="image" alt="icon" height="20" width="20" />
              <v-icon v-else>{{ icon }}</v-icon> 
              {{ message }}
            </span>
        </v-chip>
        <lb-datatablenew
          :headers="headers"
          :items="items"
          :enableslot="['code']"
          hide-default-footer
          disable-pagination
          class="elevation-0"
        >
          <template v-slot:code="{ item }">
            <span class="font-weight-bold">{{ item.code }}</span> - {{ item.name }}
          </template>
        </lb-datatablenew>
      </div>
    </template>
    <template v-slot:actions>
      <div class="d-flex justify-end gap-2">
        <base-button secondary label="Cancel" @click="close" class="" />
        <base-button 
            :primary="type === 'add' || type === 'revoke'"
            :label="buttonLabel" 
            @click="confirm" 
        />
      </div>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'UserPermissionConfirmationDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Confirm Action'
    },
    message: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    type: { // 'add' or 'revoke'
      type: String,
      default: 'add'
    },
    icon: {
      type: String,
      default: 'mdi-information-outline'
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'RU Code & Description',
          value: 'code',
          sortable: false
        }
      ];
    },
    buttonLabel() {
        return this.type === 'add' ? 'Add Access' : 'Revoke Access';
    }
  },
  methods: {
    updateValue(val) {
      this.$emit('input', val);
    },
    close() {
      this.$emit('input', false);
    },
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>
